var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_14221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 11.75,
    r: 9.75,
    fill: "#2240B1",
    stroke: "#FDBE4C",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4536 15.5332H21.0464V16.2898H10.4536V15.5332ZM19.3062 9.10181C19.6088 8.79916 19.6088 8.34519 19.3062 8.04253L17.9442 6.6806C17.6416 6.37795 17.1876 6.37795 16.885 6.6806L11.2102 12.3553V14.7765H13.6315L19.3062 9.10181ZM17.4146 7.21024L18.7765 8.57217L17.6416 9.70712L16.2797 8.34519L17.4146 7.21024ZM11.9669 14.0199V12.658L15.75 8.87483L17.1119 10.2368L13.3288 14.0199H11.9669Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_14221",
    x: 0,
    y: 0,
    width: 31.5,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_14221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_14221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_14221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1061,
    height: 12.1061,
    fill: "white",
    transform: "translate(9.69702 5.69678)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/editBtn.1836a7822689e924f029d05c397f876e.svg";
export { ForwardRef as ReactComponent };